<template>
    <div class="py-3">
        <div class="container">
            <TravelExpenseReportTabs :linksDisabled=false :expenseReportID=existingExpenseReportID ref="nav"></TravelExpenseReportTabs>
            <div class="row">
                <div class="col-md-12">
                    <div v-if="!loading && expenseReportStatusTypeId > 1" style="text-align:center; color:red;">Changes will not be saved unless Save button is clicked</div>
                    <h4 style="font-weight:900; margin-bottom:0px;">Other Section <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner></h4>
                    <div class="my-1" style="margin-top:0px;">{{expenseReportStatusTypeName}}</div>
                    <ValidationAlertComponent v-if="!loading" :expenseReportID="existingExpenseReportID" :area="'other'"></ValidationAlertComponent>
                    <div v-if="!loading">
                        <form class="">
                            <div> Ground Transporation</div>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Date</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Amount</th>
                                        <th scope="col"></th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(g,gIndex) in existingGroundTransportation.groundTransportations">
                                        <td>
                                            <!--<input type="date" class="form-control" required="required">-->
                                            <datepicker :typeable="true" :format="'MMMM dd yyyy'" input-class="form-control" :use-utc=true v-model="g.groundTransportationDate"></datepicker>
                                        </td>
                                        <td>
                                            <b-form-group>
                                                <b-form-select v-model="g.groundTransportationTypeId" :options="groundTransportationsTypes" value-field="id" text-field="displayName">
                                                    <option :value="null" disabled>Choose an option</option>
                                                </b-form-select>
                                            </b-form-group>
                                        </td>
                                        <td>
                                            <input type="number" @focus="$event.target.select()" class="form-control" placeholder="Amount" v-model="g.amount">
                                        </td>
                                        <td>
                                            <a class="btn btn-secondary btn-sm" href="#" v-if="g.amount > 75" @click="$bvModal.show('gts'+ gIndex)">Attach</a>
                                            <br>
                                            <span style="cursor: pointer">
                                                <div v-for="(gaa, gaaIndex) in g.amountAttachments">
                                                    <span @click="downloadFileInNewWindow(gaa)">{{gaa.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.GroundTransportationAttachment,gIndex,gaaIndex)">&times;</span>
                                                </div>
                                            </span>
                                            <b-modal :id="'gts' + gIndex" centered title="Add Receipt" :hide-footer=true>
                                                <AttachmentComponent :expenseReportId="existingExpenseReportID" :attachments="g.amountAttachments" @fileUploadDone="$bvModal.hide('gts'+ gIndex)"></AttachmentComponent>
                                            </b-modal>
                                        </td>
                                        <td>
                                            <button type="button" class="close" aria-label="Close" @click="showRemovalModal(ItemRemoveType.GroundTransportation,gIndex,null)">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <a class="btn btn-secondary btn-sm add-button" href="#" @click="addGroundTransporation">Add</a>
                            <div>
                                POV Mileage <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="'Starting / Ending odometer readings or Map supporting distance claimed is required.'" icon="info-circle" />
                            </div>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Date</th>
                                        <th scope="col">Method Used</th>
                                        <th scope="col">Amount</th>
                                        <th scope="col">Supporting Documentation</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(p, pIndex) in existingGroundTransportation.personalVehicleMileages">
                                        <td>
                                            <datepicker :typeable="true" :format="'MMMM dd yyyy'" input-class="form-control" :use-utc=true v-model="p.mileageDate"></datepicker>
                                        </td>
                                        <td>
                                            <b-form-group>
                                                <b-form-radio-group v-model="p.isOdemeterReading" buttons size="sm"
                                                                    :options="[{ text: 'Odometer reading', value:true },{ text: 'Map', value:false }]"></b-form-radio-group>
                                            </b-form-group>
                                            <span v-if="p.mileageInvalid" class="text-danger">POV mileage can't include decimal values</span>
                                            <input v-if="p.isOdemeterReading == false" type="number" @focus="$event.target.select()" class="form-control" placeholder="Miles" v-model="p.mileage" @keypress="isValid">
                                            <input v-if="p.isOdemeterReading == true" type="number" @focus="$event.target.select()" class="form-control" placeholder="Start Odometer Reading" v-model="p.startOdometerReading" @keypress="isValid">
                                            <input v-if="p.isOdemeterReading == true" type="number" @focus="$event.target.select()" class="form-control my-1" placeholder="End Odometer Reading" v-model="p.endOdometerReading" @keypress="isValid">
                                        </td>
                                        <td>
                                            <div v-if="mileageRates && mileageRates.length">
                                                {{getMileageAmount(p)}}
                                            </div>
                                        </td>
                                        <td>
                                            <a v-if="p.isOdemeterReading == false" class="btn btn-secondary btn-sm" href="#" @click="$bvModal.show('ma'+ pIndex)">Attach</a>
                                            <br>
                                            <span style="cursor: pointer">
                                                <div v-for="(ma,maIndex) in p.mileageAttachments">
                                                    <span @click="downloadFileInNewWindow(ma)">{{ma.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.MileageAttachment,pIndex,maIndex)">&times;</span>
                                                </div>
                                            </span>
                                            <b-modal :id="'ma' + pIndex" centered title="Add Receipt" :hide-footer=true>
                                                <AttachmentComponent :expenseReportId="existingExpenseReportID" :attachments="p.mileageAttachments" @fileUploadDone="$bvModal.hide('ma'+ pIndex)"></AttachmentComponent>
                                            </b-modal>
                                        </td>
                                        <td>
                                            <button type="button" class="close" aria-label="Close" @click="showRemovalModal(ItemRemoveType.POV,pIndex,null)">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <a class="btn btn-secondary btn-sm add-button" href="#" @click="addPOV">Add</a>
                            <!-- removed since we not calculating it -->
                            <!-- <div class="row">
                          <div class="col-md-6"></div>
                          <div class="col-md-6"> $188.00 Total Ground Transportation</div>
                        </div> -->
                            <div> Other </div>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Date</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Amount</th>
                                        <th scope="col"></th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(mc,mcIndex) in existingMiscCost.miscCosts">
                                        <td>
                                            <datepicker :typeable="true" :format="'MMMM dd yyyy'" input-class="form-control" :use-utc=true v-model="mc.miscCostDate"></datepicker>
                                        </td>
                                        <td>
                                            <b-form-group>
                                                <b-form-select v-model="mc.miscCostTypeId" :options="miscCostTypes" value-field="id" text-field="displayName">
                                                    <option :value="null" disabled>Choose an option</option>
                                                </b-form-select>
                                                <div v-if="mc.miscCostTypeId == 8 || mc.miscCostTypeId == 9">Please explain reason for not using lodging/meal section</div>
                                                <b-form-textarea v-if="mc.miscCostTypeId == 7 || mc.miscCostTypeId == 8 || mc.miscCostTypeId == 9"
                                                                 id="reason"
                                                                 class="my-1"
                                                                 v-bind:class="{'is-invalid': !mc.miscCostTypeComment }"
                                                                 v-model="mc.miscCostTypeComment"
                                                                 placeholder="Reason"
                                                                 rows="3"
                                                                 max-rows="6">
                                                </b-form-textarea>
                                            </b-form-group>
                                        </td>
                                        <td> <input type="number" @focus="$event.target.select()" class="form-control" placeholder="Amount" v-model="mc.amount"></td>
                                        <td>
                                            <a class="btn btn-secondary btn-sm" href="#" v-if="mc.amount > 75" @click="$bvModal.show('mcaa'+ mcIndex)">Attach</a>
                                            <br>
                                            <span style="cursor: pointer">
                                                <div v-for="(mca,mcaIndex) in mc.amountAttachments">
                                                    <span @click="downloadFileInNewWindow(mca)">{{mca.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.MiscCostAttachment,mcIndex,mcaIndex)">&times;</span>
                                                </div>
                                            </span>

                                            <b-modal :id="'mcaa' + mcIndex" centered title="Add Receipt" :hide-footer=true>
                                                <AttachmentComponent :expenseReportId="existingExpenseReportID" :attachments="mc.amountAttachments" @fileUploadDone="$bvModal.hide('mcaa'+ mcIndex)"></AttachmentComponent>
                                            </b-modal>
                                        </td>
                                        <td>
                                            <button type="button" class="close" aria-label="Close" @click="showRemovalModal(ItemRemoveType.Other,mcIndex,null)">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <a class="btn btn-secondary btn-sm add-button" href="#" @click="addOther">Add</a>
                            <!-- taking out for demo as we not totalling -->
                            <!-- <div class="row">
                          <div class="col-md-6"></div>
                          <div class="col-md-6"> $130.00 Total Other Travel</div>
                        </div> -->
                        </form>

                        <b-form-textarea id="supportingRemark"
                                         v-model="existingMiscCost.supportingRemark"
                                         placeholder="Supporting remarks, if needed"
                                         rows="1"
                                         max-rows="3"
                                         style="margin-top:15px;">
                        </b-form-textarea>

                        <button type="submit" class="btn btn-primary btn-lg" style="margin-top:15px;" @click="saveGroundTransportationAndOther">Save</button>
                    </div>
                </div>
                <CommentsComponent v-if="!loading && expenseReportStatusTypeId > 1" :expenseReportID="existingExpenseReportID" :area="'other'"></CommentsComponent>
                <div v-if="!loading && expenseReportStatusTypeId > 1" class="col-md-12">
                    <!-- audit history comp -->
                    <AuditHistoryComponent :expenseReportID="existingExpenseReportID" :area="'other'"></AuditHistoryComponent>
                </div>
            </div>
        </div>
        <modal title="Confirm Delete?" :is-small="true" v-if="show_modal_remove" @close="show_modal = false">
            <div class="modal-body">
                Are you sure you want to remove this item?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="removeItem(itemTypeToRemove, itemToRemove, attachmentToRemove)">Delete</button>
                <button type="button" class="btn btn-primary" @click="show_modal_remove = false">Cancel</button>
            </div>
        </modal>
        <modal title="Save progress?" :is-small="true" v-if="show_modal" @close="show_modal=false">
            <div class="modal-body">
                Save changes to expense report?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="saveAndContinue(true)">Save</button>
                <button type="button" class="btn btn-primary" @click="saveAndContinue(false)">Cancel</button>
            </div>
        </modal>
    </div>
</template>

<style>
    table {
        margin-bottom: 5px !important;
    }

    .add-button {
        margin-bottom: 35px;
    }
</style>

<script>
    // @ is an alias to /src
    import TravelExpenseReportTabs from '@/components/TravelExpenseReportTabs.vue'
    import Datepicker from 'vuejs-datepicker';
    import AttachmentComponent from '@/components/AttachmentComponent.vue'
    import AuditHistoryComponent from '@/components/AuditHistoryComponent.vue'
    import CommentsComponent from '@/components/CommentsComponent.vue'
    import TripProfileService from '@/services/TripProfileService'
    import ValidationAlertComponent from '@/components/ValidationAlertComponent.vue'
    import GroundTransportationService from '@/services/GroundTransportationService'
    import modal from '@/components/modal.vue'

    export default {
        name: 'other',
        components: {
            TravelExpenseReportTabs,
            Datepicker,
            AttachmentComponent,
            AuditHistoryComponent,
            CommentsComponent,
            ValidationAlertComponent,
            modal
        },
        async created() {
            if (this.$route.params.erid) {
                this.existingExpenseReportID = this.$route.params.erid;
                this.getGroundTransportationsType();
                this.getMiscCostsTypes();
                await this.getExistingGroundTransportation(this.existingExpenseReportID);

                if (this.existingGroundTransportation.groundTransportations.length == 0) {
                    this.addGroundTransporation();
                }
                if (this.existingGroundTransportation.personalVehicleMileages.length == 0) {
                    this.addPOV();
                }
                await this.getExistingMiscCost(this.existingExpenseReportID);
                if (this.existingMiscCost.miscCosts.length == 0) {
                    this.addOther();
                }
                let expenseReportStatus = await TripProfileService.getExpenseReportStatus(this.existingExpenseReportID);
                this.expenseReportStatusTypeId = expenseReportStatus.expenseReportStatusTypeId;
                this.expenseReportStatusTypeName = expenseReportStatus.expenseReportStatusTypeName;
                this.mileageRates = await GroundTransportationService.getMileageRates();
                this.hash = this.hashData;
            }
        },
        computed: {
            hashData: function () {
                return JSON.stringify(this.existingGroundTransportation) + JSON.stringify(this.existingMiscCost);
            }
        },
        data: function () {
            return {
                loading: true,
                expenseReportStatusTypeId: 1,
                expenseReportStatusTypeName: "",
                existingExpenseReportID: null,
                existingMiscCost: {
                    miscCosts: []
                },
                existingGroundTransportation: {
                    groundTransportations: [],
                    personalVehicleMileages: []
                },
                groundTransportationsTypes: [],
                miscCostTypes: [],
                groundTransporationAmount1: "",
                groundTransporationAmount2: "",
                povMiles1: "",
                povAmount1: "",
                otherAmount1: "",
                otherAmount2: "",
                mileageRates: [],
                hash: null,
                show_modal: false,
                navNext: null,
                show_modal_remove: false,
                itemToRemove: null,
                attachmentToRemove: null,
                itemTypeToRemove: null,
                ItemRemoveType: {
                    GroundTransportationAttachment: 0,
                    GroundTransportation: 1,
                    MileageAttachment: 2,
                    POV: 3,
                    MiscCostAttachment: 4,
                    Other: 5,
                }
            }
        },
        methods: {
            removeItem(itemType, index, attachIndex) {
                switch (itemType) {
                    case 0:
                        this.removeGroundTransportationAttachment(index, attachIndex);
                        break;
                    case 1:
                        this.removeGroundTransporation(index);
                        break;
                    case 2:
                        this.removeMileageAttachment(index, attachIndex);
                        break;
                    case 3:
                        this.removePOV(index);
                        break;
                    case 4:
                        this.removeMiscCostAttachment(index, attachIndex);
                        break;
                    case 5:
                        this.removeOther(index);
                        break;
                    default:
                        break;
                }
                this.show_modal_remove = false;
            },
            showRemovalModal(itemType, index, attachIndex) {
                this.itemToRemove = index;
                this.itemTypeToRemove = itemType;
                this.attachmentToRemove = attachIndex;
                this.show_modal_remove = true;
            },
            downloadFileInNewWindow(params) {
                let documentType = 'receipts/';
                if (params.attachmentTypeId == 2) {
                    documentType = 'InstitutionalDocuments/'
                }
                this.$http
                    .get(documentType + params.attachmentId + '/Download', {
                        responseType: 'blob',
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        const file = new Blob(
                            [response.data],
                            { type: response.headers['content-type'] });
                        const downloadUrl = window.URL.createObjectURL(file);
                        window.open(downloadUrl);
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            removeGroundTransportationAttachment(gIndex, gaaIndex) {
                this.existingGroundTransportation.groundTransportations[gIndex].amountAttachments.splice(gaaIndex, 1);
            },
            removeMileageAttachment(pIndex, maIndex) {
                this.existingGroundTransportation.personalVehicleMileages[pIndex].mileageAttachments.splice(maIndex, 1);
            },
            removeMiscCostAttachment(mcIndex, mcaIndex) {
                this.existingMiscCost.miscCosts[mcIndex].amountAttachments.splice(mcaIndex, 1);
            },

            getGroundTransportationsType() {
                this.$http
                    .get(`GroundTransportations/Types`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.groundTransportationsTypes = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            getMiscCostsTypes() {
                this.$http
                    .get(`MiscCosts/Types`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.miscCostTypes = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            async getExistingGroundTransportation(erID) {
                await this.$http
                    .get(`expensereports/${erID}/GroundTransportation`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        response.data.groundTransportations = _.orderBy(response.data.groundTransportations, "id")
                        if (response.data && response.data.personalVehicleMileages) {
                            response.data.personalVehicleMileages.forEach((pV) => {
                                pV.mileageInvalid = false;
                            });
                        }

                        this.existingGroundTransportation = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            async getExistingMiscCost(erID) {
                await this.$http
                    .get(`expensereports/${erID}/MiscCost`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.existingMiscCost = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false
                    )
            },
            async saveMiscCosts() {
                let isSuccess = false;
                await this.$http
                    .post('MiscCosts/', this.existingMiscCost, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        if (this.existingMiscCost.miscCosts.length == 0) {
                            this.addOther();
                        }
                        this.$notify({
                            group: 'success',
                            type: 'success ',
                            title: 'Success',
                            text: "Misc Costs saved successfully"
                        });
                        this.$refs.nav.getSummaryCosts();
                        isSuccess = true;
                    })
                    .catch(error => {
                        let guiError = error.response.data;

                        if (error.response.data.length >= 1) {
                            guiError = error.response.data.join("<br>")
                        }

                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: guiError
                        });
                        this.errored = true
                    })
                return isSuccess;
            },
            async saveAndContinue(save) {
                if (save) {
                    this.santizeDefaultItems();
                    let saveGroundSuccess = await this.saveGroundTransportation();
                    let saveMiscSuccess = await this.saveMiscCosts();
                    if (saveGroundSuccess && saveMiscSuccess) {
                        this.navNext()
                    } else {
                        this.show_modal = false;
                        this.navNext(false)
                    }
                }
                else {
                    this.navNext();
                    this.show_modal = false;
                }
            },
            async saveGroundTransportation() {
                let isSuccess = false;

                this.existingGroundTransportation.personalVehicleMileages.forEach(pV => {
                    if (pV.isOdemeterReading) {
                        pV.isMap = false
                        pV.mileage = null;
                    }
                    else {
                        pV.isMap = true
                        pV.startOdometerReading = null;
                        pV.endOdometerReading = null;
                    }
                    if (!pV.mileageDate) {
                        alert("no date");
                    }
                })

                await this.$http
                    .post('GroundTransportations/', this.existingGroundTransportation, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        if (this.existingGroundTransportation.groundTransportations.length == 0) {
                            this.addGroundTransporation();
                        }
                        if (this.existingGroundTransportation.personalVehicleMileages.length == 0) {
                            this.addPOV();
                        }
                        this.$notify({
                            group: 'success',
                            type: 'success ',
                            title: 'Success',
                            text: "Ground Transportation saved successfully"
                        });
                        isSuccess = true;
                    })
                    .catch(error => {
                        let guiError = error.response.data;

                        if (error.response.data.length >= 1) {
                            guiError = error.response.data.join("<br>")
                        }

                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: guiError
                        });
                        this.errored = true
                    })
                return isSuccess;
            },
            async saveGroundTransportationAndOther() {
                this.santizeDefaultItems()
                let saveGroundSuccess = await this.saveGroundTransportation();
                let saveMiscSuccess = await this.saveMiscCosts();
                if (saveGroundSuccess && saveMiscSuccess) {
                    window.scrollTo(0, 0);
                }
            },
            santizeDefaultItems() {
                //do not save seeded default entry
                this.existingGroundTransportation.groundTransportations = this.existingGroundTransportation.groundTransportations.filter((transporation) => {
                    let keep = true;
                    if (transporation.amount == null && transporation.groundTransportationDate == null && transporation.groundTransportationTypeComment == null && transporation.groundTransportationTypeId == null) {
                        keep = false;
                    }

                    return keep;
                });

                //do not save seeded default entry
                this.existingGroundTransportation.personalVehicleMileages = this.existingGroundTransportation.personalVehicleMileages.filter((mileage) => {
                    let keep = true;
                    if (mileage.mileage == null && mileage.mileageDate == null) {
                        keep = false;
                    }
                    return keep;
                });


                //do not save seeded default entry
                this.existingMiscCost.miscCosts = this.existingMiscCost.miscCosts.filter((misc) => {
                    let keep = true;
                    if (misc.amount == null && misc.miscCostDate == null && misc.miscCostTypeComment == null && misc.miscCostTypeId == null) {
                        keep = false;
                    }
                    return keep;
                });
            },
            calculatMileageFromIRSRate() {

            },
            addGroundTransporation() {
                this.existingGroundTransportation.groundTransportations.push({
                    groundTransportationDate: null,
                    amount: null,
                    groundTransportationTypeId: null,
                    groundTransportationTypeComment: null,
                    amountAttachments: []
                })
            },
            removeGroundTransporation(rgtIndex) {
                this.existingGroundTransportation.groundTransportations.splice(rgtIndex, 1);
            },
            addPOV() {
                this.existingGroundTransportation.personalVehicleMileages.push({
                    mileageDate: null,
                    mileage: null,
                    isOdemeterReading: null,
                    mileageAttachments: [],
                    mileageInvalid: false
                })
            },
            removePOV(povIndex) {
                this.existingGroundTransportation.personalVehicleMileages.splice(povIndex, 1);
            },
            addOther() {
                this.existingMiscCost.miscCosts.push({
                    miscCostDate: null,
                    amount: null,
                    miscCostTypeId: null,
                    miscCostTypeComment: null,
                    amountAttachments: []
                })
            },
            removeOther(roIndex) {
                this.existingMiscCost.miscCosts.splice(roIndex, 1);
            },
            isValid(e) {
                if (e) {
                    const regex = new RegExp(/^((\d|[1-9]\d+)(\.\d{0,1})?|\.\d{0,1})$/);
                    return regex.test(e.target.value + e.key) ? true : e.preventDefault();
                }
            },
            getMileageAmount(p) {
                if (p && p.mileageDate) {
                    let year = (new Date(p.mileageDate)).getFullYear();
                    let mileageRate = this.mileageRates.find(x => x.year == year);
                    if (mileageRate) {
                        if (p.isOdemeterReading == true && p.startOdometerReading && p.endOdometerReading) {
                            return "$" + ((p.endOdometerReading - p.startOdometerReading) * mileageRate.rate).toFixed(2);
                        }

                        if (p.isOdemeterReading == false) {
                            return "$" + (p.mileage * mileageRate.rate).toFixed(2);
                        }
                    }
                }

                return "No mileage data for selected date.";
            }
        },
        async beforeRouteLeave(to, from, next) {
            if (this.expenseReportStatusTypeId > 1) {
                next()
            }
            else {
                this.navNext = next;

                if (this.$data.hash !== this.hashData) {
                    this.show_modal = true;
                }
                else {
                    console.log("Data has not changed");
                    next();
                }          
            }
        }
    }
</script>
